import React from "react";
import { Chart } from "react-google-charts";
import Spinner from "../../../spinner/spinner";

export default function CustomerOutstandingChart({ data, loading, showChart }) {

    const sortedData = [
        data[0],
        ...data
            .slice(1)
            .sort((a, b) => {
                const getRangeStart = (range) => {
                    if (range === "Over 120") return Infinity;
                    const [start] = range.split("-").map(Number);
                    return start;
                };

                return getRangeStart(a[0]) - getRangeStart(b[0]);
            }),
    ];

    const options = {
        title: "Outstanding Amounts by Days Range",
        fontSize: 15,
        chartArea: {
            width: "50%",
        },
        hAxis: {
            title: "Days Range",
            titleTextStyle: {
                color: "#333",
                bold: true,
                fontSize: 15,
            },
            textStyle: {
                color: "#333",
            },
        },
        vAxis: {
            title: "Outstanding Amount (LKR)",
            titleTextStyle: {
                color: "#333",
                bold: true,
                fontSize: 15,
            },
            textStyle: {
                color: "#333",
            },
        },
    };

    return (
        <div style={{ display: "flex", justifyContent: "center", marginTop: '20px' }}>
            {loading ? (
                <Spinner />
            ) : (
                <React.Fragment>
                    {showChart ? (
                        sortedData.length > 1 ? (
                            <Chart
                                chartType="ColumnChart"
                                width="100%"
                                height="400px"
                                data={sortedData}
                                options={options}
                            />
                        ) : (
                            <h3>No Data Available</h3>
                        )
                    ) : null}
                </React.Fragment>
            )}
        </div>
    );
}
